<template >
  <div class="print-invoice" style="color: #000 !important;">
    <el-dialog title="Order Invoice" :visible.sync="orderDialogVisible" width="90%">

      <!-- 头部选择框 start -->
      <div style="margin: -20px 30px 20px 0;">
        <el-radio-group v-model="invoiceSelect" size="medium">
          <el-radio-button :label="generateCustomizeString('inclGST')"></el-radio-button>
          <el-radio-button :label="generateCustomizeString('plusGST')"></el-radio-button>
          <el-radio-button :label="generateCustomizeString('zeroGST')"></el-radio-button>
        </el-radio-group>
        <el-checkbox v-model="noteComments" style="margin-right: 20px; margin-left: 20px;">
          {{ generateCustomizeString('noteComments') }}
        </el-checkbox>
        <el-checkbox v-model="goodsImg" style="margin-right: 20px;">
          {{ generateCustomizeString('productThumbnail') }}
        </el-checkbox>
        <el-checkbox v-model="showProductAbbreviation" style="margin-right: 20px;">
          {{ generateCustomizeString('productAbbreviation') }}
        </el-checkbox>
        <el-checkbox v-model="showBarcode" style="margin-right: 20px;">
          {{ generateCustomizeString('barcode') }}
        </el-checkbox>
      </div>
      <!-- 头部选择框 end -->

      <div id="printIdForGoods" style="margin-top: 10px; padding: 0 10px;">
        <!-- 公司信息 start -->
        <h1 style="display: inline-block; line-height: 16px;">{{ this.shopData.display_shop_name }}</h1>
        <span style="padding-left: 20px; display: inline-block;">
          GST Number: {{ this.shopData.gst_no }}
        </span>
        <div style="margin-top: -10px; line-height: 8px; font-size: 12px;">
          <p>{{ generateCustomizeString('companyPhone') }}:{{ this.shopData.merchant_contact_phone }}</p>
          <p>{{ generateCustomizeString('email') }}:{{ this.shopData.merchant_contact_email }}</p>
          <p>{{ generateCustomizeString('companyAddress') }}:{{ this.shopData.merchant_address }}</p>
        </div>
        <div style="text-align: left;">
          <svg id="barcode2" />
        </div>
        <div style="line-height: 8px; font-size: 13px;">
          <p>{{ generateCustomizeString('tradeNo') }}: {{ this.orderDetailData.out_trade_no }}</p>
          <p>{{ generateCustomizeString('orderTime') }}: {{ this.orderDetailData.created_at | toLocalTime }}</p>
          <p>{{ generateCustomizeString('customer') }}: {{ this.orderDetailData.customer_name }}</p>
          <p v-if="this.orderCustomer.nickname">{{ generateCustomizeString('wechatName') }}: {{ this.orderCustomer.nickname }}</p>
          <p v-else>{{ generateCustomizeString('wechatName') }} : {{ generateCustomizeString('unbound') }}</p>
        </div>
        <div
          v-if="this.orderDetailData.is_pick_up === 1"
          style="margin-bottom: 10px; font-size: 14px; line-height: 10px; font-weight: bold;"
        >
          {{ generateCustomizeString('isPickUpOrder') }}
        </div>
        <div v-else>
          <p style="font-weight: 800; font-size: 12px;">
            <u>{{ generateCustomizeString('shippingAddress') }}</u>
          </p>
          <div style="padding-left: 10px; line-height: 8px; font-size: 12px;">
            <p>{{ generateCustomizeString('name') }}：{{ this.orderAddressData.consignee_name }}</p>
            <p>{{ generateCustomizeString('phoneNumber') }}：{{ this.orderAddressData.phone }}</p>
            <p>{{ generateCustomizeString('contactAddress') }}：{{ this.orderAddressData.address_detail }}</p>
            <p>{{ generateCustomizeString('identityNumber') }}：{{ this.orderAddressData.person_id }}</p>
          </div>
        </div>
        <!-- 公司信息 end -->

        <!-- 顾客商家留言 start -->
        <div v-if="noteComments === true">
          <div class="comments">
            <u>
              <b>{{ generateCustomizeString('customerNote') }}:</b>
            </u>
            '{{ this.orderDetailData.message }}'
          </div>

          <div class="comments">
            <u>
              <b>{{ generateCustomizeString('sellerComments') }}:</b>
            </u>
            {{ this.orderDetailData.to_customer_message }}
          </div>
        </div>
        <!-- 顾客商家留言 end -->

        <!-- 订单商品 start -->
        <el-col style="line-height: 14px;">
          <p style="font-weight: 800;">{{ generateCustomizeString('orderGoods') }}</p>
          <el-table
            :data="orderProductData"
            tooltip-effect="dark"
            border
            align="center"
            header-align="center"
            style="width: 701px; border-bottom: 1px solid #ebeef5; border-right: 1px solid #ebeef5; font-size: 16px; line-height: 16px;"
            v-if="this.goodsImg === false"
            key="noImg"
          >
            <el-table-column type="index" width="30" key="index"></el-table-column>
            <el-table-column
              prop="productTitle"
              key="productTitle"
              header-align="center"
              :label="generateCustomizeString('productTitle')"
            >
              <template slot-scope="scope">
                <div>{{scope.row.productTitle}}</div>
                <div
                  v-if="scope.row.productSubtitle"
                  :key="scope.row.productSubtitle"
                  style="font-size: 12px;"
                >{{scope.row.productSubtitle}}</div>
                <div style="font-size: 12px;">{{ generateCustomizeString('shippingWarehouse') }}:{{scope.row.productWarehouse}}</div>
              </template>
            </el-table-column>
            <el-table-column
              v-if="showProductAbbreviation"
              prop="productAbbreviation"
              key="productAbbreviation"
              align="center"
              header-align="center"
              :label="generateCustomizeString('productAbbreviation')"
              min-width="200"
            ></el-table-column>
            <el-table-column
              v-if="showBarcode"
              prop="bar_code"
              key="bar_code"
              header-align="center"
              :label="generateCustomizeString('barcode')"
              width="150"
            ></el-table-column>
            <el-table-column
              prop="unitPrice"
              key="unitPrice"
              align="center"
              header-align="center"
              :label="generateCustomizeString('unitPrice')"
              width="100"
            ></el-table-column>
            <el-table-column
              prop="amount"
              key="amount"
              align="center"
              header-align="center"
              :label="generateCustomizeString('quantity')"
              width="60"
            ></el-table-column>
            <el-table-column
              prop="total"
              key="total"
              align="center"
              header-align="center"
              :label="generateCustomizeString('subtotal')"
              width="109"
            ></el-table-column>
          </el-table>
          <el-table
            :data="orderProductData"
            tooltip-effect="dark"
            border
            align="center"
            header-align="center"
            style="width: 701px; border-bottom: 1px solid #ebeef5; border-right: 1px solid #ebeef5; font-size: 16px; line-height: 16px;"
            v-else
            key="img"
          >
            <el-table-column type="index" key="index" width="30"></el-table-column>
            <el-table-column
              prop="productTitle"
              key="productTitle"
              header-align="center"
              :label="generateCustomizeString('productTitle')"
            >
              <template slot-scope="scope">
                <div>{{scope.row.productTitle}}</div>
                <div
                  v-if="scope.row.productSubtitle"
                  :key="scope.row.productSubtitle"
                  style="font-size: 12px;"
                >{{scope.row.productSubtitle}}</div>
                <div style="font-size: 12px;">{{ generateCustomizeString('shippingWarehouse') }}{{scope.row.productWarehouse}}</div>
              </template>
            </el-table-column>
            <el-table-column
              v-if="showProductAbbreviation"
              prop="productAbbreviation"
              key="productAbbreviation"
              align="center"
              header-align="center"
              :label="generateCustomizeString('productAbbreviation')"
            ></el-table-column>
            <el-table-column
              v-if="showBarcode"
              prop="bar_code"
              key="bar_code"
              header-align="center"
              :label="generateCustomizeString('barcode')"
              width="150"
            ></el-table-column>
            <el-table-column
              prop="goodsImg"
              key="goodsImg"
              align="center"
              header-align="center"
              :label="generateCustomizeString('merchandiseThumbnail')"
              width="70"
              style="text-align: center;"
            >
              <template slot-scope="scope">
                <img
                  :src="scope.row.goodsImg + '?imageView2/1/w/200/h/200/q/75|imageslim'"
                  style="width:auto;height:40px;"
                />
              </template>
            </el-table-column>
            <el-table-column
              prop="unitPrice"
              key="unitPrice"
              align="center"
              header-align="center"
              :label="generateCustomizeString('unitPrice')"
              width="100"
            ></el-table-column>
            <el-table-column
              prop="amount"
              key="amount"
              align="center"
              header-align="center"
              :label="generateCustomizeString('quantity')"
              width="60"
            ></el-table-column>
            <el-table-column
              prop="total"
              key="total"
              align="center"
              header-align="center"
              :label="generateCustomizeString('subtotal')"
              width="109"
            ></el-table-column>
          </el-table>
        </el-col>
        <!-- 订单商品 end -->

        <!-- 订单金额详情 start(已含GST) start -->
        <el-col
          v-if="this.invoiceSelect === generateCustomizeString('inclGST')"
          style="margin-bottom: 30px; font-size: 12px;"
        >
          <div
            style="width: 699px; border: 1px solid #ebeef5; line-height: 20px; text-align: right;"
          >
            <span style="padding-right: 20px;">
              <span style="width: 100px; text-align: right; display: inline-block;">{{ generateCustomizeString('numberOfProducts') }}:&nbsp;</span>
              <span class="order-summary">
                {{ this.totalQuantity }}
              </span>
            </span>
          </div>
          <div
            style="width: 699px; border: 1px solid #ebeef5; line-height: 20px; text-align: right;"
          >
            <span style="padding-right: 20px;">
              <span style="width: 100px; text-align: right; display: inline-block;">{{ generateCustomizeString('goods') }}:&nbsp;</span>
              <span class="order-summary">
                NZ ${{ parseFloat(this.orderDetailData.goods_fee / 100).toFixed(2) }}
              </span>
            </span>
          </div>
          <div
            style="width: 699px; border: 1px solid #ebeef5; line-height: 20px; text-align: right;"
          >
            <span style="padding-right: 20px;">
              <span style="width: 100px; text-align: right; display: inline-block;">GST Incl:&nbsp;</span>
              <span class="order-summary">
                NZ ${{ parseFloat(this.orderDetailData.goods_fee / 100 * 3 / 23).toFixed(2) }}
              </span>
            </span>
          </div>
          <div
            style="width: 699px; border: 1px solid #ebeef5; line-height: 20px; text-align: right;"
            v-if="this.orderDetailData.order_fee_detail && this.orderDetailData.order_fee_detail.total_activity_reduction && this.orderDetailData.order_fee_detail.total_activity_reduction > 0"
          >
            <span style="padding-right: 20px;">
              <span style="width: 100px; text-align: right; display: inline-block;">{{ generateCustomizeString('promotion') }}:&nbsp;</span>
              <span
                class="order-summary"
              >-NZ ${{ parseFloat(this.orderDetailData.order_fee_detail.total_activity_reduction / 100).toFixed(2) }}</span>
            </span>
          </div>
          <div
            style="width: 699px; border: 1px solid #ebeef5; line-height: 20px; text-align: right;"
            v-if="this.orderDetailData.order_fee_detail && this.orderDetailData.order_fee_detail.total_coupon_reduction && this.orderDetailData.order_fee_detail.total_coupon_reduction > 0"
          >
            <span style="padding-right: 20px;">
              <span style="width: 100px; text-align: right; display: inline-block;">{{ generateCustomizeString('coupon') }}:&nbsp;</span>
              <span
                class="order-summary"
              >-NZ ${{parseFloat(this.orderDetailData.order_fee_detail.total_coupon_reduction / 100).toFixed(2)}}</span>
            </span>
          </div>
          <div
            style="width: 699px; border: 1px solid #ebeef5; line-height: 20px; text-align: right;"
          >
            <span style="padding-right: 20px;">
              <span style="width: 150px; text-align: right; display: inline-block;">{{ generateCustomizeString('goodsSubtotalInclGST') }}:&nbsp;</span>
              <span
                class="order-summary"
              >NZ ${{parseFloat(this.orderDetailData.cost_goods_fee_after_discounted / 100).toFixed(2)}}</span>
            </span>
          </div>
          <div
            style="width: 699px; border: 1px solid #ebeef5; line-height: 20px; text-align: right;"
          >
            <span style="padding-right: 20px;">
              <span style="width: 100px; text-align: right; display: inline-block;">{{ generateCustomizeString('sellShippingFee') }}:&nbsp;</span>
              <span
                class="order-summary"
              >NZ ${{parseFloat(this.orderDetailData.express_fee / 100).toFixed(2)}}</span>
            </span>
          </div>
          <div
            style="width: 699px; border: 1px solid #ebeef5; line-height: 20px; text-align: right;"
            v-if="this.orderDetailData.order_fee_detail && this.orderDetailData.order_fee_detail.total_express_fee_reduction && this.orderDetailData.order_fee_detail.total_express_fee_reduction > 0"
          >
            <span style="padding-right: 20px;">
              <span style="width: 100px; text-align: right; display: inline-block;">{{ generateCustomizeString('shippingFeePromotion') }}:&nbsp;</span>
              <span
                class="order-summary"
              >-NZ ${{parseFloat(this.orderDetailData.order_fee_detail.total_express_fee_reduction / 100).toFixed(2)}}</span>
            </span>
          </div>
          <div
            style="width: 699px; border: 1px solid #ebeef5; line-height: 20px; text-align: right;"
          >
            <span style="padding-right: 20px;">
              <span style="width: 100px; text-align: right; display: inline-block;">{{ generateCustomizeString('total') }}:&nbsp;</span>
              <span
                class="order-summary"
              >NZ ${{parseFloat(this.orderDetailData.fee / 100).toFixed(2)}}</span>
            </span>
          </div>

          <!-- 支付方式 start -->
          <div style="width: 699px; border: 1px solid #ebeef5; line-height: 20px; text-align: right;">
            <span style="padding-right: 20px;">
              <span style="width: 100px; text-align: right; display: inline-block;">{{ generateCustomizeString('payType') }}:&nbsp;</span>
              <span class="order-summary">
                <span v-for="type in this.orderDetailData.transactions" :key="type.id">
                  <span v-if="[1, 2].includes(type.status)">
                    {{ type.pay_type_string }}:
                    ${{ parseFloat(type.fee / 100).toFixed(2) }}<br>
                  </span>
                </span>
              </span>
            </span>
          </div>
          <!-- 支付方式 end -->
        </el-col>
        <!-- 订单金额详情 start(已含GST) end -->

        <!-- 订单金额详情 start(加GST) start -->
        <el-col
          v-else-if="this.invoiceSelect === generateCustomizeString('plusGST')"
          style="margin-bottom: 30px; font-size: 12px;"
        >
          <div
            style="width: 699px; border: 1px solid #ebeef5; line-height: 20px; text-align: right;"
          >
            <span style="padding-right: 20px;">
              <span style="width: 100px; text-align: right; display: inline-block;">{{ generateCustomizeString('numberOfProducts') }}:&nbsp;</span>
              <span
                class="order-summary"
              >{{this.totalQuantity}}</span>
            </span>
          </div>
          <div
            style="width: 699px; border: 1px solid #ebeef5; line-height: 20px; text-align: right;"
          >
            <span style="padding-right: 20px;">
              <span style="width: 100px; text-align: right; display: inline-block;">{{ generateCustomizeString('goods') }}:&nbsp;</span>
              <span
                class="order-summary"
              >NZ ${{parseFloat(this.orderDetailData.goods_fee / 100).toFixed(2)}}</span>
            </span>
          </div>
          <div
            style="width: 699px; border: 1px solid #ebeef5; line-height: 20px; text-align: right;"
          >
            <span style="padding-right: 20px;">
              <span style="width: 100px; text-align: right; display: inline-block;">15% GST:&nbsp;</span>
              <span
                class="order-summary"
              >NZ ${{parseFloat(this.orderDetailData.goods_fee / 100 * 0.15).toFixed(2)}}</span>
            </span>
          </div>
          <div
            style="width: 699px; border: 1px solid #ebeef5; line-height: 20px; text-align: right;"
            v-if="this.orderDetailData.order_fee_detail && this.orderDetailData.order_fee_detail.total_activity_reduction && this.orderDetailData.order_fee_detail.total_activity_reduction > 0"
          >
            <span style="padding-right: 20px;">
              <span style="width: 100px; text-align: right; display: inline-block;">{{ generateCustomizeString('promotion') }}:&nbsp;</span>
              <span
                class="order-summary"
              >-NZ ${{parseFloat(this.orderDetailData.order_fee_detail.total_activity_reduction / 100).toFixed(2)}}</span>
            </span>
          </div>
          <div
            style="width: 699px; border: 1px solid #ebeef5; line-height: 20px; text-align: right;"
            v-if="this.orderDetailData && this.orderDetailData.order_fee_detail.total_coupon_reduction && this.orderDetailData.order_fee_detail.total_coupon_reduction > 0"
          >
            <span style="padding-right: 20px;">
              <span style="width: 100px; text-align: right; display: inline-block;">{{ generateCustomizeString('coupon') }}:&nbsp;</span>
              <span
                class="order-summary"
              >-NZ ${{parseFloat(this.orderDetailData.order_fee_detail.total_coupon_reduction / 100).toFixed(2)}}</span>
            </span>
          </div>
          <div
            style="width: 699px; border: 1px solid #ebeef5; line-height: 20px; text-align: right;"
          >
            <span style="padding-right: 20px;">
              <span style="width: 150px; text-align: right; display: inline-block;">{{ generateCustomizeString('goodsSubtotalInclGST')}}:&nbsp;</span>
              <span
                class="order-summary"
              >NZ ${{parseFloat(this.orderDetailData.goods_fee / 100 * 1.15 - (this.orderDetailData.order_fee_detail.total_activity_reduction / 100) - (this.orderDetailData.order_fee_detail.total_coupon_reduction / 100)).toFixed(2)}}</span>
            </span>
          </div>
          <div
            style="width: 699px; border: 1px solid #ebeef5; line-height: 20px; text-align: right;"
          >
            <span style="padding-right: 20px;">
              <span style="width: 100px; text-align: right; display: inline-block;">{{ generateCustomizeString('sellShippingFee')}}:&nbsp;</span>
              <span
                class="order-summary"
              >NZ ${{parseFloat(this.orderDetailData.express_fee / 100).toFixed(2)}}</span>
            </span>
          </div>
          <div
            style="width: 699px; border: 1px solid #ebeef5; line-height: 20px; text-align: right;"
            v-if="this.orderDetailData.order_fee_detail && this.orderDetailData.order_fee_detail.total_express_fee_reduction && this.orderDetailData.order_fee_detail.total_express_fee_reduction > 0"
          >
            <span style="padding-right: 20px;">
              <span style="width: 100px; text-align: right; display: inline-block;">{{ generateCustomizeString('shippingFeePromotion') }}:&nbsp;</span>
              <span
                class="order-summary"
              >-NZ ${{parseFloat(this.orderDetailData.order_fee_detail.total_express_fee_reduction / 100).toFixed(2)}}</span>
            </span>
          </div>
          <div
            style="width: 699px; border: 1px solid #ebeef5; line-height: 20px; text-align: right;"
          >
            <span style="padding-right: 20px;">
              <span style="width: 100px; text-align: right; display: inline-block;">{{ generateCustomizeString('total') }}:&nbsp;</span>
              <span
                class="order-summary"
              >NZ ${{parseFloat((this.orderDetailData.goods_fee / 100 * 1.15) - (this.orderDetailData.order_fee_detail.total_activity_reduction / 100) - (this.orderDetailData.order_fee_detail.total_coupon_reduction / 100) + (this.orderDetailData.order_fee_detail.total_express_fee_after_discounted / 100)).toFixed(2)}}</span>
            </span>
          </div>
          <!-- 支付方式 start -->
          <div style="width: 699px; border: 1px solid #ebeef5; line-height: 20px; text-align: right;">
            <span style="padding-right: 20px;">
              <span style="width: 100px; text-align: right; display: inline-block;">{{ generateCustomizeString('payType') }}:&nbsp;</span>
              <span class="order-summary">
                <span v-for="type in this.orderDetailData.transactions" :key="type.id">
                  <span v-if="[1, 2].includes(type.status)">
                    {{ type.pay_type_string }}:(
                    ${{ parseFloat(type.fee / 100).toFixed(2) }})
                  </span>
                </span>
              </span>
            </span>
          </div>
          <!-- 支付方式 end -->
        </el-col>
        <!-- 订单金额详情 start(加GST) end -->

        <!-- 订单金额详情 start(0 GST) start -->
        <el-col
          v-else-if="this.invoiceSelect === generateCustomizeString('zeroGST')"
          style="margin-bottom: 30px; font-size: 12px;"
        >
          <div
            style="width: 699px; border: 1px solid #ebeef5; line-height: 20px; text-align: right;"
          >
            <span style="padding-right: 20px;">
              <span style="width: 100px; text-align: right; display: inline-block;">{{ generateCustomizeString('numberOfProducts') }}:&nbsp;</span>
              <span
                class="order-summary"
              >{{this.totalQuantity}}</span>
            </span>
          </div>
          <div
            style="width: 699px; border: 1px solid #ebeef5; line-height: 20px; text-align: right;"
          >
            <span style="padding-right: 20px;">
              <span style="width: 100px; text-align: right; display: inline-block;">{{ generateCustomizeString('goods') }}:&nbsp;</span>
              <span
                class="order-summary"
              >NZ ${{parseFloat(this.orderDetailData.goods_fee / 100).toFixed(2)}}</span>
            </span>
          </div>
          <div
            style="width: 699px; border: 1px solid #ebeef5; line-height: 20px; text-align: right;"
          >
            <span style="padding-right: 20px;">
              <span style="width: 100px; text-align: right; display: inline-block;">GST:&nbsp;</span>
              <span class="order-summary">NZ $0.00</span>
            </span>
          </div>
          <div
            style="width: 699px; border: 1px solid #ebeef5; line-height: 20px; text-align: right;"
            v-if="this.orderDetailData.order_fee_detail && this.orderDetailData.order_fee_detail.total_activity_reduction && this.orderDetailData.order_fee_detail.total_activity_reduction > 0"
          >
            <span style="padding-right: 20px;">
              <span style="width: 100px; text-align: right; display: inline-block;">{{ generateCustomizeString('promotionActivity') }}:&nbsp;</span>
              <span
                class="order-summary"
              >-NZ ${{parseFloat(this.orderDetailData.order_fee_detail.total_activity_reduction / 100).toFixed(2)}}</span>
            </span>
          </div>
          <div
            style="width: 699px; border: 1px solid #ebeef5; line-height: 20px; text-align: right;"
            v-if="this.orderDetailData && this.orderDetailData.order_fee_detail.total_coupon_reduction && this.orderDetailData.order_fee_detail.total_coupon_reduction > 0"
          >
            <span style="padding-right: 20px;">
              <span style="width: 100px; text-align: right; display: inline-block;">{{ generateCustomizeString('coupon') }}:&nbsp;</span>
              <span
                class="order-summary"
              >-NZ ${{parseFloat(this.orderDetailData.order_fee_detail.total_coupon_reduction / 100).toFixed(2)}}</span>
            </span>
          </div>
          <div
            style="width: 699px; border: 1px solid #ebeef5; line-height: 20px; text-align: right;"
          >
            <span style="padding-right: 20px;">
              <span style="width: 150px; text-align: right; display: inline-block;">{{ generateCustomizeString('goodsSubtotalZeroGST') }}:&nbsp;</span>
              <span
                class="order-summary"
              >NZ ${{parseFloat(this.orderDetailData.cost_goods_fee_after_discounted / 100).toFixed(2)}}</span>
            </span>
          </div>
          <div
            style="width: 699px; border: 1px solid #ebeef5; line-height: 20px; text-align: right;"
          >
            <span style="padding-right: 20px;">
              <span style="width: 100px; text-align: right; display: inline-block;">{{ generateCustomizeString('sellShippingFee') }}:&nbsp;</span>
              <span
                class="order-summary"
              >NZ ${{parseFloat(this.orderDetailData.express_fee / 100).toFixed(2)}}</span>
            </span>
          </div>
          <div
            style="width: 699px; border: 1px solid #ebeef5; line-height: 20px; text-align: right;"
            v-if="this.orderDetailData.order_fee_detail && this.orderDetailData.order_fee_detail.total_express_fee_reduction && this.orderDetailData.order_fee_detail.total_express_fee_reduction > 0"
          >
            <span style="padding-right: 20px;">
              <span style="width: 100px; text-align: right; display: inline-block;">{{ generateCustomizeString('shippingFeePromotion') }}:&nbsp;</span>
              <span
                class="order-summary"
              >-NZ ${{parseFloat(this.orderDetailData.order_fee_detail.total_express_fee_reduction / 100).toFixed(2)}}</span>
            </span>
          </div>
          <div
            style="width: 699px; border: 1px solid #ebeef5; line-height: 20px; text-align: right;"
          >
            <span style="padding-right: 20px;">
              <span style="width: 100px; text-align: right; display: inline-block;">{{ generateCustomizeString('total') }}:&nbsp;</span>
              <span
                class="order-summary"
              >NZ ${{parseFloat(this.orderDetailData.order_fee_detail.total_fee_after_discounted / 100).toFixed(2)}}</span>
            </span>
          </div>
          <!-- 支付方式 start -->
          <div style="width: 699px; border: 1px solid #ebeef5; line-height: 20px; text-align: right;">
            <span style="padding-right: 20px;">
              <span style="width: 100px; text-align: right; display: inline-block;">{{ generateCustomizeString('payType') }}:&nbsp;</span>
              <span class="order-summary">
                <span v-for="type in this.orderDetailData.transactions" :key="type.id">
                  <span v-if="[1, 2].includes(type.status)">
                    {{ type.pay_type_string }}:
                    ${{ parseFloat(type.fee / 100).toFixed(2) }}
                  </span>
                </span>
              </span>
            </span>
          </div>
          <!-- 支付方式 end -->
        </el-col>
        <!-- 订单金额详情 start(0 GST) end -->

        <!-- 页脚文字 start -->
        <div style="line-height: 8px; page-break-before: auto;">
          <p style="font-weight: bold;">Important:</p>
          <p
            style="padding-left: 20px;"
          >1. This is an electronic generated invoice so does not require any signature.</p>
          <p
            style="padding-left: 20px;"
          >2. Please read all terms and polices for returns, replacement and other issues.</p>
        </div>
        <!-- 页脚文字 end -->

      </div>

      <div id="printIdForGoodsEpson" style="width: 100%;display: none;">
        <div style="text-align: center;margin: 0;padding:0;">
          <!-- <img style="width: 44%;" :src="this.shopData.shop_logo_url" /> -->
          <br />
          <p style="margin-top: 12px;">
            <b>{{ this.shopData.display_shop_name }}</b>
          </p>
          <p style="margin-top: 4px;">{{ this.shopData.merchant_address }}</p>
          <p style="margin-top: 4px;">
            TEL: {{ this.shopData.merchant_contact_phone }} GST: {{ this.shopData.gst_no }}
          </p>
          <p style="margin-top: 4px;">{{ this.shopData.shop_pc_url }}</p>
        </div>
        <p style="margin-top: 16px; margin-left: 20px;">
          <b>Sales Receipt</b>
          <span style="float: right; margin-right: 20px;">
            {{ this.orderDetailData.created_at | toLocalTime }}
          </span>
        </p>

        <table
          style="margin-top:5px; padding-right: 20px; padding-left: 20px; border-top: 2px solid gray;border-bottom: 2px solid gray; border-top-style: dashed;border-bottom-style: dashed;padding-top: 6px;padding-bottom: 6px;width: 100%;"
        >
          <tr>
            <th>Item Name</th>
            <th>Price</th>
            <th>Qty.</th>
            <th style="text-align: right;">Total</th>
          </tr>
          <tr v-for="item in orderProductData" style="text-align: center;" :key="item.productTitle">
            <td style="width: 30%;font-size: 8px;text-align: left;">{{ item.productTitle }}</td>
            <td>{{ item.unitPrice }}</td>
            <td>{{ item.amount }}</td>
            <td style="text-align: right;">{{ item.total }}</td>
          </tr>
        </table>
        <div v-if="this.invoiceSelect === generateCustomizeString('inclGST')" style="padding-right: 25px;">
          <p style="text-align: right;line-height: 18px;margin-top: 4px;position: relative;">
            <span style="position: absolute;right: 100px;">Sub Total</span> $
            <b>{{ parseFloat(this.orderDetailData.goods_fee / 100).toFixed(2) }}</b>
            <br />
          </p>
          <p style="text-align: right;line-height: 18px;margin-top: 4px;position: relative;">
            <span style="position: absolute;right: 100px;">GST Incl</span> $
            <b>{{ parseFloat(this.orderDetailData.goods_fee / 100 * 3 / 23).toFixed(2) }}</b>
            <br />
          </p>
          <p style="text-align: right;line-height: 18px;margin-top: 4px;position: relative;">
            <span style="position: absolute;right: 100px;">Total</span> $
            <b>{{ parseFloat(this.orderDetailData.goods_fee / 100).toFixed(2) }}</b>
            <br />
          </p>
          <p style="text-align: right;line-height: 18px;position: relative;">
            <span style="position: absolute;right: 100px;">Shipping Fee</span> $
            <b>{{ parseFloat(this.orderDetailData.express_fee / 100).toFixed(2) }}</b>
            <br />
          </p>
          <p style="text-align: right;line-height: 18px;position: relative;">
            <span style="position: absolute;right: 100px;">Total + Shpping</span> $
            <b>{{ parseFloat(this.orderDetailData.fee / 100).toFixed(2) }}</b>
            <br />
          </p>
          <!-- 支付方式 start -->
          <p style="text-align: right;line-height: 18px;position: relative;">
            <span style="position: absolute;right: 100px;">Total + Shpping</span> $
            <span v-for="type in this.orderDetailData.transactions" :key="type.id">
              <span v-if="[1, 2].includes(type.status)">
                {{ type.pay_type_string }}:
                ${{ parseFloat(type.fee / 100).toFixed(2) }}
              </span>
            </span>
            <br />
          </p>
        </div>
        <div v-if="this.invoiceSelect === generateCustomizeString('plusGST')" style="padding-right: 25px;">
          <p style="text-align: right;line-height: 18px;margin-top: 4px;position: relative;">
            <span style="position: absolute;right: 100px;">Sub Total</span> $
            <b>{{parseFloat(this.orderDetailData.goods_fee / 100).toFixed(2)}}</b>
            <br />
          </p>
          <p style="text-align: right;line-height: 18px;margin-top: 4px;position: relative;">
            <span style="position: absolute;right: 100px;">15% GST</span> $
            <b>{{parseFloat(this.orderDetailData.goods_fee / 100 * 0.15).toFixed(2)}}</b>
            <br />
          </p>
          <p style="text-align: right;line-height: 18px;margin-top: 4px;position: relative;">
            <span style="position: absolute;right: 100px;">Total</span> $
            <b>{{parseFloat(this.orderDetailData.goods_fee / 100 * 1.15).toFixed(2)}}</b>
            <br />
          </p>
          <p style="text-align: right;line-height: 18px;position: relative;">
            <span style="position: absolute;right: 100px;">Shipping Fee</span> $
            <b>{{parseFloat(this.orderDetailData.express_fee / 100).toFixed(2)}}</b>
            <br />
          </p>
          <p style="text-align: right;line-height: 18px;position: relative;">
            <span style="position: absolute;right: 100px;">Total + Shpping</span> $
            <b>{{parseFloat((this.orderDetailData.goods_fee / 100 * 1.15) + (this.orderDetailData.express_fee / 100)).toFixed(2)}}</b>
            <br />
          </p>
        </div>
        <div v-if="this.invoiceSelect === generateCustomizeString('zeroGST')" style="padding-right: 25px;">
          <p style="text-align: right;line-height: 18px;margin-top: 4px;position: relative;">
            <span style="position: absolute;right: 100px;">Sub Total</span> $
            <b>{{parseFloat(this.orderDetailData.goods_fee / 100).toFixed(2)}}</b>
            <br />
          </p>
          <p style="text-align: right;line-height: 18px;margin-top: 4px;position: relative;">
            <span style="position: absolute;right: 100px;">GST</span> $
            <b>0</b>
            <br />
          </p>
          <p style="text-align: right;line-height: 18px;margin-top: 4px;position: relative;">
            <span style="position: absolute;right: 100px;">Total</span> $
            <b>{{parseFloat(this.orderDetailData.goods_fee / 100).toFixed(2)}}</b>
            <br />
          </p>
          <p style="text-align: right;line-height: 18px;position: relative;">
            <span style="position: absolute;right: 100px;">Shipping Fee</span> $
            <b>{{parseFloat(this.orderDetailData.express_fee / 100).toFixed(2)}}</b>
            <br />
          </p>
          <p style="text-align: right;line-height: 18px;position: relative;">
            <span style="position: absolute;right: 100px;">Total + Shpping</span> $
            <b>{{parseFloat(this.orderDetailData.fee / 100).toFixed(2)}}</b>
            <br />
          </p>
        </div>
        <!-- <p style="margin-top:8px;margin-bottom: 8px; text-align: center;width: 100%;">7 days unconditional refund for products in resalable condition.</p> -->
        <div style="text-align: center;padding-bottom: 10px; margin-top: 10px;">
          <svg id="barcode" />
        </div>
      </div>

      <!-- 页脚打印按钮 start -->
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="printWithEpson" style="width: 100px;">{{ generateCustomizeString('printReceipt') }}</el-button>
        <el-button type="primary" @click="printWithDevice" style="width: 100px;">{{ generateCustomizeString('printA4') }}</el-button>
        <el-button @click="orderDialogVisible = false" style="width: 100px;">{{ generateCustomizeString('close') }}</el-button>
      </span>
      <!-- 页脚打印按钮 end -->

    </el-dialog>
  </div>
</template>

<script>
import request from '@/utils/request'
import { generateCustomizeString } from '@/utils/i18n'
import JsBarcode from 'jsbarcode'

export default {
  name: 'PrintInvoice',
  data() {
    return {
      orderDialogVisible: false,
      orderDetailData: { created_at: '2019-01-01 00:00:00' },
      orderProductData: [],
      orderAddressData: [],
      orderCustomer: [],
      shopData: [],
      ids: '',
      invoiceSelect: this.generateCustomizeString('inclGST'),
      totalQuantity: 0,
      goodsImg: false,
      noteComments: false,
      showProductAbbreviation: false,
      showBarcode: false
    }
  },
  methods: {
    generateCustomizeString,
    handlePrintClick(ids) {
      // const that = this
      request({
        url: 'order/' + ids,
        method: 'get'
      })
        .then(response => {
          this.orderDetailData = response.data
          this.orderAddressData = response.data.order_address
          if (
            response.data.customer.wechat_auths.length &&
            response.data.customer.wechat_auths[0].user_info
          ) {
            this.orderCustomer =
              response.data.customer.wechat_auths[0].user_info
          }

          const data = []
          this.totalQuantity = 0
          for (let i = 0; i < response.data.order_goods.length; i++) {
            var obj = {}
            obj.productTitle = response.data.order_goods[i].product_full_name
            obj.productAbbreviation = response.data.order_goods[i].product_abbreviation
            obj.productSubtitle = response.data.order_goods[i].product_subtitle
            obj.productId = response.data.order_goods[i].goods_spu_id
            obj.productWarehouse = response.data.order_goods[i].warehouse_name
            obj.goodsImg = response.data.order_goods[i].first_image_url
            obj.bar_code = response.data.order_goods[i].bar_code
            obj.unitPrice =
              '$' +
              parseFloat(
                response.data.order_goods[i].order_price / 100
              ).toFixed(2)
            obj.amount = response.data.order_goods[i].quantity
            obj.total =
              '$' +
              parseFloat(
                (response.data.order_goods[i].order_price *
                  response.data.order_goods[i].quantity) /
                  100
              ).toFixed(2)

            data[i] = obj
            this.totalQuantity += response.data.order_goods[i].quantity
          }
          this.orderProductData = data

          this.orderDialogVisible = true
        })
        .catch(error => {
          console.warn(error)
        })
        .finally(() => {
          this.getBarcode()
        })

      request({
        url: 'basic',
        method: 'get'
      })
        .then(response => {
          this.shopData = response.data
        })
        .catch(error => {
          console.warn(error)
        })
    },
    getBarcode() {
      JsBarcode('#barcode2', this.orderDetailData.out_trade_no, {
        width: 2,
        height: 30,
        fontSize: 10,
        displayValue: false
      })
      console.log(this.orderDetailData.out_trade_no)
    },
    printWithEpson() {
      this.orderDialogVisible = false
      var mywindow = window.open('', 'PRINT')
      mywindow.document.write(
        '<html><head><style>@page{size:auto;margin:0mm 0mm 0mm 0mm;padding:0;}body{margin: 0;}p{margin:0;font-size:10px;}th{font-weight:lighter;font-size:10px;}td{font-size:10px;}</style><script type="text/javascript" src="https://cdn.jsdelivr.net/npm/jsbarcode@3.8.0/dist/JsBarcode.all.min.js"></scr' +
          'ipt></head>'
      )
      mywindow.document.write('<body >')
      mywindow.document.write(
        document.getElementById('printIdForGoodsEpson').innerHTML
      )
      const out_trade_no = this.orderDetailData.out_trade_no
      mywindow.document.write(
        '<script>JsBarcode("#barcode", "' +
          out_trade_no.substr(out_trade_no.length - 8) +
          '", {width:2,height: 32,fontSize: 12})</scr' +
          'ipt></body><script>setInterval(window.print(), 1000);</scr' +
          'ipt>'
      )
      mywindow.document.write('</html>')
      mywindow.document.close()
      mywindow.focus()
    },
    printWithDevice() {
      this.orderDialogVisible = false
      var mywindow = window.open('', 'PRINT')
      mywindow.document.write(
        '<html><head><link rel="stylesheet" type="text/css" href="https://unpkg.com/element-ui/lib/theme-chalk/index.css" media="print"><title>订单 Invoice</title><script type="text/javascript" src="https://unpkg.com/element-ui/lib/index.js"></scr' +
          'ipt><script type="text/javascript" src="https://cdn.jsdelivr.net/npm/jsbarcode@3.8.0/dist/JsBarcode.all.min.js"></scr' +
          'ipt><style type="text/css"> .el-table td, .el-table th { padding: 2px 0 !important; line-height: 14px; font-size:14px; } </style></head>'
      )
      mywindow.document.write('<body >')
      mywindow.document.write(
        document.getElementById('printIdForGoods').innerHTML
      )
      // mywindow.document.write('</body><script>setInterval(window.print(), 1000);</scr' + 'ipt>')
      const out_trade_no = this.orderDetailData.out_trade_no
      mywindow.document.write(
        '<script>JsBarcode("#barcode", "' +
          out_trade_no +
          '", {width:2,height: 32,fontSize: 10,displayValue: false})</scr' +
          'ipt></body><script>setInterval(window.print(), 1000);</scr' +
          'ipt>'
      )
      mywindow.document.write('</html>')
      mywindow.document.close()
      mywindow.focus()
    }
  }
}
</script>

<style type="text/css">
.print-invoice .el-dialog__wrapper {
  z-index: 1000000 !important;
}
.comments {
  margin-bottom: 5px;
  font-size: 16px;
  font-weight: bold;
  line-height: 20px;
  width: 700px;
}
.order-summary {
  width: 80px;
  text-align: left;
  display: inline-block;
}
/*.el-select-dropdown {
    z-index: 1000001 !important;
  }*/
/*.el-popover {
    z-index: 10000002 !important;
  }*/
</style>
